import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  TextbookActionsHandler,
  TextbookActionsHandlerToken,
} from '../../../../../external/providers/textbook-actions-handler';
import { ModalSize } from '../../models';
import { ModalPositionConfig } from "../../models/modal-position-config";

const BG_DEFAULT_LEFT_POSITION = '0';
const BG_DEFAULT_TOP_POSITION = '0';
const BG_DEFAULT_WIDTH = '100%';
const BG_DEFAULT_HEIGHT = '100%';

@Component({
  selector: 'txtb-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalComponent {
  // TODO zmienić nazwę na layout

  @Input() title!: string;
  @Input() isDraggable = true;
  @Input() type: 'action' | 'plain' = 'action';
  @Input() size: ModalSize = ModalSize.DEFAULT;
  @Input() set bgPositionConfig(value: ModalPositionConfig | null) {
    this.bgLeftPosition = value?.left || BG_DEFAULT_LEFT_POSITION;
    this.bgTopPosition = value?.top || BG_DEFAULT_TOP_POSITION;
    this.bgWidth = value?.width || BG_DEFAULT_WIDTH;
    this.bgHeight = value?.height || BG_DEFAULT_HEIGHT;
  };

  @Input() positionConfig: ModalPositionConfig | null = null;
  @Output() closeModal = new EventEmitter<void>();
  @ViewChild('wrapper') wrapper!: ElementRef;

  @HostBinding('style.--bg-left') bgLeftPosition: string = BG_DEFAULT_LEFT_POSITION;
  @HostBinding('style.--bg-top') bgTopPosition: string = BG_DEFAULT_TOP_POSITION;
  @HostBinding('style.--bg-width') bgWidth: string = BG_DEFAULT_WIDTH;
  @HostBinding('style.--bg-height') bgHeight: string = BG_DEFAULT_HEIGHT;

  readonly ModalSize = ModalSize;

  constructor(
    @Inject(TextbookActionsHandlerToken) private textbookActionsHandler: TextbookActionsHandler,
    private activatedRoute: ActivatedRoute
  ) {}

  @HostListener('click', ['$event']) onClick(event: MouseEvent): void {
    if (event.target === this.wrapper.nativeElement && this.type === 'action') {
      this.textbookActionsHandler.backToTextbook(this.activatedRoute);
    }
  }

  back(): void {
    if (this.type === 'action') {
      this.textbookActionsHandler.backToTextbook(this.activatedRoute);
    }
    if (this.type === 'plain') {
      this.closeModal.emit();
    }
  }
}
